type LoadingDotsProps = {
  className?: string;
  dotClassName?: string;
  dotColors?: readonly [string, string, string];
  label?: string;
};

const defaultDotColors = ["bg-[#E8521A]", "bg-[#1A8C7A]", "bg-white"] as const;
const animationDelays = ["0ms", "140ms", "280ms"] as const;

export default function LoadingDots({
  className = "",
  dotClassName = "",
  dotColors = defaultDotColors,
  label = "Chargement"
}: LoadingDotsProps) {
  return (
    <span
      className={`inline-flex items-center justify-center gap-1.5 ${className}`}
      role="status"
      aria-label={label}
    >
      {dotColors.map((dotColor, index) => (
        <span
          key={`${dotColor}-${index}`}
          className={`h-2.5 w-2.5 rounded-full ${dotColor} ${dotClassName} animate-bounce`}
          style={{
            animationDelay: animationDelays[index],
            animationDuration: "900ms"
          }}
        />
      ))}
      <span className="sr-only">{label}</span>
    </span>
  );
}
